<template>
  <div class="q-imei-container main-color">
    <label class="label-2cols q-label" v-html="question.q"></label>
    <md-field class="input-2cols">
      <md-input
        placeholder="IMEI"
        type="number"
        :disabled="readOnly"
        v-model="answer"
        @change="emitValueIMEI"
      ></md-input>
    </md-field>
  </div>
</template>

<script>
export default {
  name: "imei-question",
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    },
    answerProp:{
      type: String,
      default: ""
    },
    readOnly:{
      type:Boolean,
      default: false
    }
  },
  methods: {
    emitValueIMEI: function() {
      //console.log(this.answer);
      this.$emit("emit-value", { "q_id": this.question.q_id, "q_type": this.question.q_type, "ans": this.answer });
    }
  },
  data: function() {
    return {
      answer: this.answerProp
    };
  }
};
</script>
